import { NgModule, Component, ViewChild, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { UserDataApi, LoopBackAuth } from '../../../../../assets/js/lb-sdk';
import { finalize } from 'rxjs/operators';
import { USER_ROLES } from '../../../../enums';
import { Event } from '../../../../interfaces';
import { HasRolePipe } from '../../../../pipes/has-role.pipe';

interface UserForm {
  id?: string,
  userClass?: string,
  data?: any
};

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.css']
})
export class UserFormComponent implements OnInit {
  @ViewChild('registration') registration;
  @ViewChild('adminRegistration') adminRegistration;
  USER_ROLES: typeof USER_ROLES = USER_ROLES;
  data: UserForm;
  userRoles = USER_ROLES;
  error: string;
  loading: boolean = false;

  constructor(
    public modal: BsModalRef,
    private loopBackAuth: LoopBackAuth,
    private hasRolePipe: HasRolePipe
  ) { }

  ngOnInit() {
    this.data = this.data || {
      data: {}
    };
    if (
      this.hasRolePipe.transform(this.getUser().roles, USER_ROLES.ALTERNATIVE_CHANNEL) ||
      this.hasRolePipe.transform(this.getUser().roles, USER_ROLES.BDM)
    ) {
      this.data.userClass = 'CLIENT';
    } else if (this.hasRolePipe.transform(this.getUser().roles, USER_ROLES.ICT)) {
      this.data.userClass = 'MAXICARE';
    }
  }

  dismiss(reason: string) {
    if (this.registration && this.registration.partner && this.registration.partner.created) {
      return this.close('success');
    }
    this.modal.content.reason = reason;
    this.modal.hide();
  }

  close(message) {
    this.modal.content.result = message;
    this.modal.hide();
  }

  isLoading(): boolean {
    return this.loading ||
      (this.registration && this.registration.isLoading && this.registration.isLoading() || false) ||
      (this.adminRegistration && this.adminRegistration.isLoading && this.adminRegistration.isLoading() || false);
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }
}
